var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"position":"fixed","right":"0","height":"85px","width":"85px","margin":"10px 20px","transform":"translateZ(0)","z-index":"9998","bottom":"0"},attrs:{"name":"iframe-webchat","id":"iframe-webchat","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }